import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Col,
  Row,
} from 'reactstrap';

import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Spinner from '../../components/spinner';

import withAPI from '../../hocs/with-api';
import HttpErrorHandler from '../../components/http-error-handler';
import ClientForm from '../../components/clients-form';
import ButtonWithIcon from '../../components/button-with-icon';

class EditClient extends PureComponent {
  constructor() {
    super();
    this.state = { client: null };
  }

   componentDidMount = async () => {
     const { httpRequest, history, match: { params: { id: clientId } } } = this.props;
     const response = await httpRequest({
       method: 'get',
       url: `/clients/${clientId}`,
     }).catch(() => {
       history.push('/dashboard');
     });
     const client = _.get(response, 'data');
     if (client) {
       this.setState({
         client,
       });
     }
   }

   updateClient = async ({
     name,
     addresses,
   }) => {
     const {
       t, httpRequest, match: { params: { id } }, history,
     } = this.props;
     const patched = await httpRequest({
       method: 'patch',
       url: `clients/${id}`,
       data: {
         name,
         addresses,
       },
     });
     if (patched) {
       history.push({
         pathname: _.get(this.props, 'location.state.prevPath', '/clients'),
         flash: {
           type: 'success',
           message: t('clients.edited'),
         },
       });
     }
   }

   onBackButtonClick = () => {
     const { history } = this.props;
     history.goBack();
   }

   render() {
     const { client } = this.state;
     const {
       httpGetLoading,
       httpGetDone,
       t,
       httpPatchFailed,
       httpPatchFailReason,
       httpPatchLoading,
     } = this.props;

     return (
       <>
         <Col md="12">
           <Row className="with-back-button">
             <p className="lf-main-text form-name-text">{ t('clients.edit') }</p>
             <ButtonWithIcon
               height="40px"
               icon="/assets/back-icon.png"
               width="50px"
               className="float-right back-button"
               onClick={this.onBackButtonClick}
             />
           </Row>
         </Col>
         {
            httpGetLoading && <Spinner />
          }
         {
          !httpGetLoading && httpGetDone && client
          && (
            <Col md="12">
              {
                httpPatchFailed && httpPatchFailReason
                && <HttpErrorHandler {...httpPatchFailReason} />
              }
              <ClientForm
                t={t}
                client={client}
                onSubmit={this.updateClient}
                isConfirmButtonLoading={httpPatchLoading}
              />
            </Col>
          )
          }
       </>
     );
   }
}

EditClient.propTypes = {
  httpRequest: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  httpGetLoading: PropTypes.bool,
  httpGetDone: PropTypes.bool,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  httpPatchFailed: PropTypes.bool,
  httpPatchFailReason: PropTypes.object,
  httpPatchLoading: PropTypes.bool,
};

EditClient.defaultProps = {
  httpGetLoading: true,
  httpGetDone: false,
  httpPatchFailed: false,
  httpPatchFailReason: undefined,
  httpPatchLoading: false,
};

export default compose(
  withTranslation(),
  withAPI,
  withRouter,
)(EditClient);
